export default __webpack_public_path__ + "static/media/105.0240abd1.png";